import { ExtensionUpdateWarning } from "@/components/features/ClubImport/ExtensionUpdateWarning";
import { Dialog } from "@/design-system/Dialog/Dialog";
import { useTranslation } from "@repo/shared/i18n";

export type ExtensionUpdateDialogData = {
  /** The import action the CTA was about to run; runs on Continue. None: no Continue, the action needs the update. */
  onContinue?: () => void;
};

/**
 * Raised by an import CTA when the extension is behind the latest release.
 * The warning brings its own heading, so the dialog runs without a title.
 */
export const ExtensionUpdateDialog = ({
  data,
  onClose,
}: {
  data?: ExtensionUpdateDialogData;
  onClose: () => void;
}) => {
  const { t } = useTranslation("common");

  return (
    <Dialog
      isOpen
      onClose={onClose}
      title=""
      width={520}
      negLabel={t("cancel")}
      posLabel={data?.onContinue ? t("continue") : ""}
      onPositive={() => data?.onContinue()}
    >
      {/* Right margin keeps the warning clear of the close button. */}
      <ExtensionUpdateWarning className="mr-8" />
    </Dialog>
  );
};
